/**
 * Toggles the `.scrolled` class on the Rapid Quality nav once the page
 * has scrolled past 12px. Uses a passive listener for scroll performance.
 */
(function () {
  var THRESHOLD = 12;
  var nav = document.querySelector('[data-rq-nav]');
  if (!nav) return;

  var scrolled = false;
  function update() {
    var isScrolled = window.scrollY > THRESHOLD;
    if (isScrolled === scrolled) return;
    scrolled = isScrolled;
    nav.classList.toggle('scrolled', scrolled);
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
})();
